module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeOK),
      expression: "codeOK"
    }],
    staticClass: "index page",
    attrs: {
      "data-title": _vm.title
    }
  }, [_c('view-box', {
    ref: "scroller"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isWX && _vm.isWKB),
      expression: "!isWX && isWKB"
    }]
  }, [_c('div', {
    staticClass: "follow"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0"
    }
  }, [_c('img', {
    staticClass: "follow__logo",
    attrs: {
      "src": "static/common/images/wkb_blue.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "follow__text"
  }, [_c('p', [_vm._v("关注悟空保让保险不再买错！")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "follow__btn",
    attrs: {
      "id": "focus_us"
    }
  }, [_vm._v("关注我们")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "1"
    }
  }, [_c('img', {
    staticClass: "follow__close",
    attrs: {
      "src": "static/common/images/close.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.isWKB) ? _c('div', {
    staticClass: "back-to-m"
  }, [_c('div', {
    staticClass: "back-to-m__top"
  }, [_c('img', {
    staticClass: "back-to-m__home",
    attrs: {
      "src": "https://image.wkbinsure.com/m/home_icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "back-to-m__nav"
  }, [_c('ul', [_c('li', {
    staticClass: "back-to-m__index",
    on: {
      "click": _vm.gotoMIndex
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('li', {
    staticClass: "back-to-m__cat",
    on: {
      "click": _vm.gotoMCat
    }
  }, [_vm._v("产品分类")]), _vm._v(" "), _c('li', {
    staticClass: "back-to-m__center",
    on: {
      "click": _vm.gotoMCenter
    }
  }, [_vm._v("个人中心")])]), _vm._v(" "), _c('img', {
    staticClass: "back-to-m__arrow",
    attrs: {
      "src": "https://image.wkbinsure.com/m/nav_arrow_v2.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": _vm.banner
    }
  })]), _vm._v(" "), (_vm.partners) ? _c('div', {
    staticClass: "partners",
    class: {
      'partners__one': _vm.partnersOne === true
    }
  }, _vm._l((_vm.partners), function(partner, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": partner
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.isWKB && _vm.inActTime) ? _c('div', {
    staticStyle: {
      "background": "#fff",
      "font-size": "0",
      "margin-top": "10px",
      "padding": "15px"
    }
  }, [_c('a', {
    staticClass: "cf",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "href": "/bxj"
    }
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/common/images/act_bxj.png",
      "alt": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrap"
  }, [_c('sticky', {
    ref: "sticky",
    attrs: {
      "scroll-box": "vux_view_box_body",
      "check-sticky-support": false
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_vm._v("产品介绍")]), _vm._v(" "), _c('li', [_vm._v("常见问题")]), _vm._v(" "), _c('li', [_vm._v("用户评价"), (_vm.message.isShowSum) ? _c('span', [_vm._v("(" + _vm._s(_vm.message.totalNumber) + ")")]) : _vm._e()]), _vm._v(" "), _c('li', [_vm._v("理赔流程")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 p-t-10 introduction nav-target"
  }, [(_vm.voice) ? [_c('div', {
    staticClass: "voice",
    style: ({
      borderLeftColor: _vm.themeColor
    })
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.voiceIcon
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "wx",
    attrs: {
      "src": _vm.wxIcon
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.voiceTitle))]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.voiceSubtitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.onOff
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatAudioTime")(_vm.currentAudioTime)))])])]), _vm._v(" "), _c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.voiceUrl
    },
    on: {
      "canplay": _vm.getAudioDuration
    }
  })] : _vm._e(), _vm._v(" "), _vm._l((_vm.introduction), function(intro, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      style: ({
        textAlign: intro.align
      })
    }, [(intro.type === 'img') ? _c('img', {
      staticClass: "response",
      style: ({
        width: intro.width || '90%'
      }),
      attrs: {
        "src": intro.src
      }
    }) : _vm._e(), _vm._v(" "), (intro.type === 'img-text') ? _c('div', {
      staticClass: "img-text",
      staticStyle: {
        "margin-left": "-10px",
        "margin-right": "-10px"
      }
    }, _vm._l((intro.blocks), function(block, index) {
      return _c('div', {
        key: index,
        staticClass: "block"
      }, [_c('div', [_c('img', {
        staticClass: "response",
        attrs: {
          "src": block.img
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_c('p', [_vm._v(_vm._s(block.title)), (block.appendTitle) ? _c('span', [_vm._v("(" + _vm._s(block.appendTitle) + ")")]) : _vm._e(), (block.titleDetail) ? _c('label', {
        staticClass: "titlesmall",
        on: {
          "click": function($event) {
            _vm.openDetailDialog(block.title, block.titleDetail)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": "static/common/images/what.png"
        }
      })]) : _vm._e()]), _vm._v(" "), _c('p', {
        staticClass: "small"
      }, [_c('span', [_vm._v(_vm._s(block.subtitle))]), _vm._v(" "), (block.detail) ? _c('label', {
        on: {
          "click": function($event) {
            _vm.openDetailDialog(block.subtitle, block.detail)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": "static/common/images/what.png"
        }
      })]) : _vm._e()])])])
    })) : _vm._e(), _vm._v(" "), (intro.type === 'pk') ? _c('div', {
      staticClass: "pk"
    }, [(intro.title) ? _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(intro.title)), (intro.subtitle) ? _c('span', [_vm._v(" (" + _vm._s(intro.subtitle) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "images"
    }, [_c('img', {
      staticClass: "response",
      attrs: {
        "src": intro.img
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "victory",
      attrs: {
        "src": intro.victory
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, _vm._l((_vm.introBtns), function(btn, index) {
    return _c('a', {
      key: index,
      staticClass: "theme-bg-color",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.openNewWindow(btn.url)
        }
      }
    }, [_vm._v(_vm._s(btn.name))])
  }))], 2), _vm._v(" "), _c('m-question', {
    staticClass: "nav-target",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('m-message', {
    staticClass: "nav-target",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "message": _vm.message
    },
    on: {
      "changeMessage": function($event) {
        _vm.changeMessage($event)
      }
    }
  }), _vm._v(" "), _c('m-process', {
    staticClass: "nav-target",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('tabbar', {
    staticClass: "bottom",
    slot: "bottom"
  }, [_c('m-buy', {
    attrs: {
      "measureState": _vm.measureState,
      "isShow": _vm.isShow
    },
    on: {
      "clickBuy": _vm.onClickBuy
    }
  })], 1)], 1), _vm._v(" "), (_vm.hasMeasure) ? _c('div', {
    staticClass: "measure-wrap",
    class: {
      'measure-wrap--active': _vm.measureState
    }
  }, [_c('m-measure', {
    on: {
      "close": function () {
        _vm.measureState = false;
        _vm.isShow = true
      }
    }
  }), _vm._v(" "), _c('tabbar', {
    staticClass: "bottom"
  }, [_c('m-buy', {
    attrs: {
      "measureState": _vm.measureState,
      "isShow": _vm.isShow
    },
    on: {
      "clickBuy": _vm.onClickBuy
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('x-dialog', {
    staticClass: "detail-dialog",
    attrs: {
      "hide-on-blur": ""
    },
    model: {
      value: (_vm.showDetailDialog),
      callback: function($$v) {
        _vm.showDetailDialog = $$v
      },
      expression: "showDetailDialog"
    }
  }, [_c('div', {
    staticClass: "close"
  }, [_c('span', [_vm._v(_vm._s(_vm.detailDialogTitle))]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": _vm.closeDetailDialog
    }
  })]), _vm._v(" "), (_vm.detailDialogTabs.length > 1) ? _c('tab', _vm._l((_vm.detailDialogTabs), function(tab, index) {
    return _c('tab-item', {
      key: index,
      attrs: {
        "selected": _vm.currentDetailDialogIndex === index
      },
      on: {
        "on-item-click": function($event) {
          _vm.currentDetailDialogIndex = index
        }
      }
    }, [_vm._v(_vm._s(tab))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.detailDialogItems[_vm.currentDetailDialogIndex]), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('x-dialog', {
    staticClass: "detail-dialog",
    attrs: {
      "hide-on-blur": ""
    },
    model: {
      value: (_vm.showDetail),
      callback: function($$v) {
        _vm.showDetail = $$v
      },
      expression: "showDetail"
    }
  }, [_c('div', {
    staticClass: "close"
  }, [_c('span', [_vm._v("投保每满500减50")]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": function($event) {
        _vm.showDetail = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('p', [_vm._v("1. 活动时间：2017.11.23-2017.11.27")]), _vm._v(" "), _c('p', [_vm._v("2. 参与规则：活动期间购买年金产品，每满500元即减50元；")]), _vm._v(" "), _c('p', [_vm._v("3. 返现方式：投保成功后，减免金额自动放入悟空保-个人中心-我的钱包中，保单过犹豫期后，您可以直接提现")])])]), _vm._v(" "), _c('confirm', {
    staticClass: "agent",
    attrs: {
      "value": _vm.showAgent,
      "title": "统计业绩需要，请正确填写以下信息",
      "close-on-confirm": false
    },
    on: {
      "on-confirm": _vm.onConfirmAgent
    }
  }, [_c('group', [_c('x-input', {
    attrs: {
      "show-clear": false,
      "title": "姓名",
      "placeholder": "请输入姓名",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkAgentName
    },
    model: {
      value: (_vm.agentName),
      callback: function($$v) {
        _vm.agentName = $$v
      },
      expression: "agentName"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": false,
      "title": "工号",
      "placeholder": "请输入工号",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkAgentJobNum
    },
    model: {
      value: (_vm.agentJobNum),
      callback: function($$v) {
        _vm.agentJobNum = $$v
      },
      expression: "agentJobNum"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isDailiren) ? _c('a', {
    staticClass: "kefu cf",
    attrs: {
      "href": 'tel:' + _vm.tel
    }
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/common/images/kefu.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showJihuashuGuide && !_vm.isJihuashuGuideClicked && !_vm.isProspectus),
      expression: "showJihuashuGuide && !isJihuashuGuideClicked && !isProspectus"
    }],
    staticClass: "jihuashu-guide"
  }, [_c('img', {
    attrs: {
      "src": _vm.jihuashuGuideImgs[_vm.jihuashuGuideIndex],
      "alt": ""
    },
    on: {
      "click": _vm.jihuashuGuide
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShare && _vm.showShareProducts),
      expression: "showShare && showShareProducts"
    }],
    staticClass: "wx-share-alert",
    on: {
      "click": function($event) {
        _vm.showShare = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/common/images/wx_share_alert.png",
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0219df17","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 646
// module chunks = 1